// extracted by mini-css-extract-plugin
export default {"root":"MissingColumbusData_root__jnYJK","title":"MissingColumbusData_title__qgg2a","subtitle":"MissingColumbusData_subtitle__epuxp","text":"MissingColumbusData_text__WWqsw"};